<script lang="ts">
    import WishlistTheme from "@apps/wishlist/components/WishlistTheme/WishlistTheme.svelte";
    import { WishlistsQuery } from "@apps/wishlist/queries/WishlistsQuery";
    import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
    import WishlistsStorefrontValuesService from "@apps/wishlist/services/WishlistsStorefrontValuesService";
    import { CommonModule } from "@modules/common_module/CommonModule";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { onMount } from "svelte";
    import { container } from "tsyringe";

    import WishlistIcon from "@components/WishlistIcon/WishlistIcon.svelte";

    export let heartColor: string;
    export let wishlistsQuery: WishlistsQuery;
    export let wishlistsService: WishlistsService;
    export let wishlistsStorefrontValuesService: WishlistsStorefrontValuesService;
    export let afterWidgetInject: () => void;

    const wishlistBranding$ =
        wishlistsStorefrontValuesService.selectWishlistsBranding();
    const itemsTotalCount$ = wishlistsQuery.itemsTotalCount$;
    const blockSettingsEmptyColor = "rgba(0,0,0,0)";

    onMount(() => {
        wishlistsService.getItemsTotalCount();

        afterWidgetInject();
    });

    const urlsBuilder = container.resolve(CommonModule).exports.urlsBuilder;

    const i18nModule = container.resolve(I18nModule);
    const open_wishlist_page_button_accessibility_label$ =
        i18nModule.exports.i18n.selectT(
            "wishlist.critical.GoToWishlistPageHeaderWidget",
            "open_wishlist_page_button_accessibility_label"
        );

    const computedHeartColor =
        heartColor && heartColor !== blockSettingsEmptyColor
            ? heartColor
            : $wishlistBranding$?.wishlistIconSettings.heartColor;
</script>

{#if $wishlistBranding$}
    <WishlistTheme branding={$wishlistBranding$}>
        <a
            class="gw-wl-go-to-wishlist-header-widget"
            data-items-count={$itemsTotalCount$}
            href={urlsBuilder.createWishlistPageUrl()}
            aria-label={$open_wishlist_page_button_accessibility_label$}
            style="--gw-wl-wishlistIconSettings-heartColor: {computedHeartColor}"
        >
            <WishlistIcon
                width={20}
                height={20}
                isFilled={false}
                iconSettings={$wishlistBranding$.wishlistIconSettings}
            />
        </a>
    </WishlistTheme>
{/if}

<style lang="postcss">
    .gw-wl-go-to-wishlist-header-widget {
        /* For info about button size see
         * https://shopify.dev/docs/apps/online-store/theme-app-extensions/ux-guidelines#key-principles-for-app-blocks-in-the-header-section
         * @savchenko-dev
         */
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
</style>
